import React, { useState, useEffect } from 'react';
import SelectColourButton from './selectColourButton';

export default function TextEditModule({ eventModuleRow, updateEventModuleRow }) {
    const [textDisplayName, setTextDisplayName] = useState(eventModuleRow.name);
    const [bStyle, setBStyle] = useState(eventModuleRow.colour);

    useEffect(() => {
        setTextDisplayName(eventModuleRow.name);
        setBStyle(eventModuleRow.colour);
    }, [eventModuleRow]);

    function handleChange(e) {
        const newName = e.target.value;
        setTextDisplayName(newName);
        updateEventModuleRow({
            name: newName,
            colour: bStyle,
            event_grouping_seq: eventModuleRow.event_grouping_seq,
            module_type_id: eventModuleRow.module_type_id,
        });
    }

    function colourSelected(newStyle) {
        setBStyle(newStyle);
        updateEventModuleRow({
            name: textDisplayName,
            colour: newStyle,
            event_grouping_seq: eventModuleRow.event_grouping_seq,
            module_type_id: eventModuleRow.module_type_id,
        });
    }

    return (
        <div>
            <input type="text" style={{ width: '50%' }} className="form-control input-md"
                name="textDisplayName" value={textDisplayName}
                onChange={handleChange} placeholder="Message Box Name" />
            <SelectColourButton
                title="Select Colour"
                groupingSequence={eventModuleRow.event_grouping_seq}
                selectedColour={colourSelected}
                bStyle={bStyle} />
        </div>
    );
}
